<script lang="ts">
	import ReviewPreview from '$lib/review/reviewPreview.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import PageGrid from '../components/pageGrid.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			text: ISbRichtext;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<PageGrid>
	<div class="col-span-full" use:editable={content}>
		<ReviewPreview>
			{#snippet ratedLabel()}
				<p>
					<a href="#reviews-widget" class="font-semibold underline">See reviews</a>
				</p>
			{/snippet}

			{#snippet text()}
				<SbRichtext text={content.text} />
			{/snippet}
		</ReviewPreview>
	</div>
</PageGrid>
